import { positionKey } from "../chess/positionKey.ts";
import type { ExplorerSnapshot } from "./enrich.ts";
import { whiteRepertoireMoves } from "./coverage.ts";
import type { SanityReport } from "./sanity.ts";
import type { LessonCourse, LessonMove } from "./schema.ts";

function popularityFor(move: LessonMove): "main" | "common" | "sideline" | "rare" {
  if (move.role === "repertoire" || move.role === "mainline") return "main";
  if (move.role === "transposition") return "common";
  if (move.role === "mistake") return "rare";
  return "sideline";
}

function shareFor(popularity: string): number {
  if (popularity === "main") return 0.52;
  if (popularity === "common") return 0.18;
  if (popularity === "sideline") return 0.07;
  return 0.01;
}

export function qualitativeSnapshot(course: LessonCourse, title: string): ExplorerSnapshot {
  const positions: ExplorerSnapshot["positions"] = {};
  for (const node of Object.values(course.nodes)) {
    if (!node.moves.length) continue;
    positions[positionKey(node.fen)] = {
      moves: node.moves.map((move) => {
        const popularity = popularityFor(move);
        return { san: move.san, popularity, share: shareFor(popularity) };
      }),
    };
  }
  return {
    source: "authoring-snapshot",
    importedAt: "2026-09-19",
    attribution: `Qualitative explorer labels captured at authoring time from the curated ${title} course. Not a live Lichess or Chess.com query.`,
    positions,
  };
}

export function authoringSanity(course: LessonCourse): SanityReport {
  return {
    courseId: course.id,
    engine: "authoring-review",
    depth: 0,
    generatedAt: "2026-09-19",
    entries: whiteRepertoireMoves(course).map((white) => ({
      after: white.after,
      san: white.san,
      band: "top" as const,
      note: white.move.explanation,
    })),
  };
}
